import { REFRESH_NAVIGATION } from "../actions/navigation";
import {
  PERMISSION_ARTICLES_READ,
  PERMISSION_ADMIN_USERS_READ,
  PERMISSION_MAP_CHARTS_READ,
  PERMISSION_PRODUCTIONS_READ,
  PERMISSION_VACANCIES_READ,
  PERMISSION_TALENTS_READ,
  PERMISSION_TALENTS_READ_GLOBAL,
  PERMISSION_CLIENTS_ACCOUNTS_MANAGEMENT,
  PERMISSION_ADMINMESSAGES_READ,
} from "../constants";
import { checkPermission } from "../panel-admin/common/functions/permissions";

const urls = [
  {
    title: "Dashboard",
    items: [
      {
        url: "/dashboard",
        icon: "dashboard",
        title: "Dashboard",
        items: [],
      },
    ],
  },
  {
    title: "Offers",
    items: [
      {
        url: "/offers/active",
        icon: "group_work",
        title: "Active offers",
        permission: PERMISSION_VACANCIES_READ,
        items: [],
      },
    ],
  },
  {
    title: "Productions",
    items: [
      {
        url: "/productions/active",
        icon: "subscriptions",
        title: "Active productions",
        permission: PERMISSION_PRODUCTIONS_READ,
        items: [],
      },
      {
        url: "/productions/draft",
        icon: "subscriptions",
        title: "Draft productions",
        permission: PERMISSION_PRODUCTIONS_READ,
        items: [],
      },
      {
        url: "/productions/past",
        icon: "subscriptions",
        title: "Past productions",
        permission: PERMISSION_PRODUCTIONS_READ,
        items: [],
      },
    ],
  },
  {
    title: "Community",
    items: [
      {
        url: "/talents",
        icon: "people",
        title: "Talents",
        permission: PERMISSION_TALENTS_READ,
        items: [],
      },
      {
        url: "/profiles/pending",
        icon: "description",
        title: "Pending",
        permission: PERMISSION_TALENTS_READ,
        items: [],
      },
      {
        url: "/profiles/incomplete",
        icon: "description",
        title: "Incomplete",
        permission: PERMISSION_TALENTS_READ,
        items: [],
      },
      {
        url: "/profiles/rejected",
        icon: "description",
        title: "Rejected",
        permission: PERMISSION_TALENTS_READ,
        items: [],
      },
      {
        url: "/talent-export",
        icon: "file_download",
        title: "Talent export",
        permission: PERMISSION_TALENTS_READ_GLOBAL,
        items: [],
      },
      {
        url: "/adminMessages/list",
        icon: "message",
        title: "Messages",
        permission: PERMISSION_ADMINMESSAGES_READ,
        items: [],
      },
    ],
  },
  {
    title: "Content management",
    items: [
      {
        url: "/news",
        icon: "format_list_bulleted",
        title: "News",
        permission: PERMISSION_ARTICLES_READ,
        items: [],
      },
      {
        url: "/map-charts/overview",
        icon: "poll",
        title: "Map charts",
        permission: PERMISSION_MAP_CHARTS_READ,
        items: [],
      },
    ],
  },
  {
    title: "User management",
    items: [
      {
        url: "/users",
        icon: "people",
        title: "Users",
        permission: PERMISSION_ADMIN_USERS_READ,
        items: [],
      },
    ],
  },
  {
    title: "Client access",
    items: [
      {
        url: "/clientaccounts/pending",
        icon: "person_add",
        title: "Pending requests",
        permission: PERMISSION_CLIENTS_ACCOUNTS_MANAGEMENT,
        items: [],
      },
      {
        url: "/clientaccounts",
        icon: "account_circle",
        title: "Client accounts",
        permission: PERMISSION_CLIENTS_ACCOUNTS_MANAGEMENT,
        items: [],
      },
    ],
  },
 /*
  {
    title: 'Navigation',
    items: [
      {
        url: '',
        icon: 'dashboard',
        title: 'Dashboards',
        badge: {
          className: 'badge badge-danger badge-sm badge-outline',
          title: 'New'
        },
        items: [
          {
            url: '/dashboards/analytics',
            icon: '',
            title: 'Analytics',
            items: []
          },
          {
            url: '/dashboards/geographic',
            icon: '',
            title: 'Geographic',
            items: []
          },
          {
            url: '/dashboards/e-commerce',
            icon: '',
            title: 'E-commerce',
            items: []
          }
        ]
      },
      {
        url: '',
        icon: 'bookmark_border',
        title: 'Demos',
        items: [
          {
            url: '/demos/demo-1',
            icon: '',
            title: 'Demo 1',
            items: []
          },
          {
            url: '/demos/demo-2',
            icon: '',
            title: 'Demo 2',
            items: []
          },
          {
            url: '/demos/demo-3',
            icon: '',
            title: 'Demo 3',
            items: []
          },
          {
            url: '/demos/demo-4',
            icon: '',
            title: 'Demo 4',
            items: []
          },
          {
            url: '/demos/demo-5',
            icon: '',
            title: 'Demo 5',
            items: []
          },
          {
            url: '/demos/demo-6',
            icon: '',
            title: 'Demo 6',
            items: []
          }
        ]
      },
      {
        url: '',
        icon: 'code',
        title: 'Layouts',
        badge: {
          className: 'badge badge-info badge-sm badge-rounded badge-outline',
          title: '3'
        },
        items: [
          {
            url: '/layouts/default-sidebar-1',
            icon: '',
            title: 'Default sidebar 1',
            items: []
          },
          {
            url: '/layouts/collapsed-sidebar-1',
            icon: '',
            title: 'Collapsed sidebar 1',
            items: []
          },
          {
            url: '/layouts/top-navigation-1',
            icon: '',
            title: 'Top navigation 1',
            items: []
          }
        ]
      },
      {
        url: '',
        icon: 'extension',
        title: 'Widgets',
        items: [
          {
            url: '/widgets/activity-widgets',
            icon: '',
            title: 'Activity widgets',
            items: []
          },
          {
            url: '/widgets/area-chart-widgets',
            icon: '',
            title: 'Area chart widgets',
            items: []
          },
          {
            url: '/widgets/bar-chart-widgets',
            icon: '',
            title: 'Bar chart widgets',
            items: []
          },
          {
            url: '/widgets/donut-chart-widgets',
            icon: '',
            title: 'Donut chart widgets',
            items: []
          },
          {
            url: '/widgets/icon-widgets',
            icon: '',
            title: 'Icon widgets',
            items: []
          },
          {
            url: '/widgets/line-chart-widgets',
            icon: '',
            title: 'Line chart widgets',
            items: []
          },
          {
            url: '/widgets/pie-chart-widgets',
            icon: '',
            title: 'Pie chart widgets',
            items: []
          },
          {
            url: '/widgets/table-widgets',
            icon: '',
            title: 'Table widgets',
            items: []
          },
          {
            url: '/widgets/text-widgets',
            icon: '',
            title: 'Text widgets',
            items: []
          },
          //          {
          //            url: '/widgets/timeline-widgets',
          //            icon: '',
          //            title: 'Timeline widgets',
          //            items: []
          //          },
          {
            url: '/widgets/user-widgets',
            icon: '',
            title: 'User widgets',
            items: []
          }
        ]
      }
    ]
  },
  {
    title: 'Components',
    items: [
      {
        url: '',
        icon: 'label',
        title: 'UI Elements',
        items: [
          {
            url: '/ui-elements/badges',
            icon: '',
            title: 'Badges',
            items: []
          },
          {
            url: '/ui-elements/breadcrumbs',
            icon: '',
            title: 'Breadcrumbs',
            items: []
          },
          {
            url: '/ui-elements/buttons',
            icon: '',
            title: 'Buttons',
            items: []
          },
          //          {
          //            url: '/ui-elements/cards',
          //            icon: '',
          //            title: 'Cards',
          //            items: []
          //          },
          //          {
          //            url: '/ui-elements/dropdowns',
          //            icon: '',
          //            title: 'Dropdowns',
          //            items: []
          //          },
          {
            url: '/ui-elements/images',
            icon: '',
            title: 'Images',
            items: []
          },
          {
            url: '/ui-elements/lists',
            icon: '',
            title: 'Lists',
            items: []
          },
          {
            url: '/ui-elements/pagination',
            icon: '',
            title: 'Pagination',
            items: []
          },
          {
            url: '/ui-elements/progress-bars',
            icon: '',
            title: 'Progress bars',
            items: []
          },
          {
            url: '/ui-elements/social-media-buttons',
            icon: '',
            title: 'Social media buttons',
            items: []
          },
          {
            url: '/ui-elements/tabs',
            icon: '',
            title: 'Tabs',
            items: []
          },
          {
            url: '/ui-elements/typography',
            icon: '',
            title: 'Typography',
            items: []
          }
        ]
      },
      {
        url: '',
        icon: 'assignment',
        title: 'Forms',
        badge: {
          className: 'badge badge-success badge-sm badge-outline',
          title: 'Important'
        },
        items: [
          {
            url: '/forms/default-forms',
            icon: '',
            title: 'Default forms',
            items: []
          },
          {
            url: '/forms/input-groups',
            icon: '',
            title: 'Input groups',
            items: []
          },
          //          {
          //            url: '/forms/steps',
          //            icon: '',
          //            title: 'Form steps',
          //            items: []
          //          },
          {
            url: '/forms/validation',
            icon: '',
            title: 'Form validation',
            items: []
          },
          {
            url: '/forms/sliders',
            icon: '',
            title: 'Sliders',
            items: []
          },
          {
            url: '/forms/react-datetime',
            icon: '',
            title: 'Date picker',
            items: []
          },
          {
            url: '/forms/react-select',
            icon: '',
            title: 'React select',
            items: []
          }
        ]
      },
      {
        url: '',
        icon: 'format_list_bulleted',
        title: 'Tables',
        items: [
          {
            url: '/tables/reactable',
            icon: '',
            title: 'Reactable',
            items: []
          },
          {
            url: '/tables/default-tables',
            icon: '',
            title: 'Default tables',
            items: []
          }
        ]
      },
      {
        url: '',
        icon: 'notifications',
        title: 'Notifications',
        badge: {
          className: 'badge badge-warning badge-sm badge-rounded badge-outline',
          title: '3'
        },
        items: [
          {
            url: '/ui-elements/alerts',
            icon: '',
            title: 'Alerts',
            items: []
          },
          {
            url: '/ui-elements/modals',
            icon: '',
            title: 'Modals',
            items: []
          },
          {
            url: '/notifications/reapop',
            icon: '',
            title: 'Reapop',
            items: []
          }
        ]
      }
    ]
  },
  {
    title: 'Other',
    items: [
      {
        url: '',
        icon: 'map',
        title: 'Maps',
        badge: {
          className: 'badge badge-danger badge-sm badge-rounded badge-outline',
          title: '3'
        },
        items: [
          {
            url: '/maps/google-maps',
            icon: '',
            title: 'Google maps',
            items: []
          },
          {
            url: '/maps/vector-maps',
            icon: '',
            title: 'Vector maps',
            items: []
          }
        ]
      },
      {
        url: '',
        icon: 'explore',
        title: 'Icons',
        badge: {
          className: 'badge badge-info badge-sm badge-outline',
          title: 'New'
        },
        items: [
          {
            url: '/icons/flags',
            icon: '',
            title: 'Flags',
            items: []
          },
          {
            url: '/icons/font-awesome',
            icon: '',
            title: 'Font awesome',
            items: []
          },
          {
            url: '/icons/ionicons',
            icon: '',
            title: 'Ionicons',
            items: []
          },
          {
            url: '/icons/material-design-icons',
            icon: '',
            title: 'Material design icons',
            items: []
          },
          {
            url: '/icons/simple-line-icons',
            icon: '',
            title: 'Simple line icons',
            items: []
          },
          {
            url: '/icons/weather-icons',
            icon: '',
            title: 'Weather icons',
            items: []
          }
        ]
      }
    ]
  },
  {
    title: 'Extras',
    items: [
      {
        url: '',
        icon: 'insert_drive_file',
        title: 'Pages',
        items: [
          {
            url: '/pages/contact-us',
            icon: '',
            title: 'Contact us',
            items: []
          },
          {
            url: '/pages/create-account',
            icon: '',
            title: 'Create account',
            items: []
          },
          {
            url: '/pages/empty-page',
            icon: '',
            title: 'Empty page',
            items: []
          },
          {
            url: '/pages/error-page',
            icon: '',
            title: 'Error page',
            items: []
          },
          {
            url: '/pages/login',
            icon: '',
            title: 'Login',
            items: []
          },
          {
            url: '/pages/reset-password',
            icon: '',
            title: 'Reset password',
            items: []
          },
          {
            url: '/pages/subscribe',
            icon: '',
            title: 'Subscribe',
            items: []
          },
          {
            url: '/pages/under-maintenance',
            icon: '',
            title: 'Under maintenance',
            items: []
          },
          {
            url: '/pages/unlock-account',
            icon: '',
            title: 'Unlock account',
            items: []
          }
          //          {
          //            url: '/pages/user-profile',
          //            icon: '',
          //            title: 'User profile',
          //            items: []
          //          }
        ]
      },
      {
        url: '',
        icon: 'pie_chart',
        title: 'Charts',
        badge: {
          className: 'badge badge-primary badge-sm badge-rounded badge-outline',
          title: '2'
        },
        items: [
          {
            url: '/charts/chartist',
            icon: '',
            title: 'Chartist',
            items: []
          },
          {
            url: '/charts/recharts',
            icon: '',
            title: 'Recharts',
            items: []
          }
        ]
      }
    ]
  },
  {
    title: 'Docs',
    items: [
      {
        url: '',
        icon: 'info',
        title: 'Documentation',
        badge: {
          className: 'badge badge-danger badge-sm badge-outline',
          title: 'New'
        },
        items: [
          {
            url: '/documentation/installation',
            icon: '',
            title: 'Installation',
            items: []
          },
          {
            url: '/documentation/code-structure',
            icon: '',
            title: 'Code structure',
            items: []
          },
          {
            url: '/documentation/faq',
            icon: '',
            title: 'FAQ',
            items: []
          },
          {
            url: '/documentation/change-log',
            icon: '',
            title: 'Change log',
            items: []
          },
          {
            url: '/documentation/credits',
            icon: '',
            title: 'Credits',
            items: []
          }
        ]
      }
    ]
  }
*/
];

// Verifies permissions to urls
function getAllowedUrls() {
  var result = [];

  for (let i = 0; i < urls.length; i++) {
    let url = { ...urls[i] };
    url.items = url.items.filter((item) => {
      return !item.permission || checkPermission(item.permission);
    });

    if (url.items.length > 0) {
      result.push(url);
    }
  }

  return result;
}

export function navigation(state = Array.from(getAllowedUrls()), action) {
  switch (action.type) {
    case "SET_NAVIGATION":
      return Object.assign({}, state, {
        ...action.navigation,
      });

    case REFRESH_NAVIGATION:
      return Array.from(getAllowedUrls());

    default:
      return state;
  }
}
